import React from 'react'

import { Link } from 'react-router-dom'

import Icon from '../icon'

import * as S from './styles'

const FaqButton = () => (
  <S.Container>
    <S.Tag>FAQ</S.Tag>
    <Link to="/faq/CONTRATANTE">
      <S.OutterCircle>
        <Icon name="question" />
      </S.OutterCircle>
    </Link>
  </S.Container>
)

export default FaqButton
